import Badge from "./Badge";
import Avatar from "./Avatar";
import { productType } from "types/productType";

export default function ViewTitle ({
	info
}: any) {

	console.log("info,,,,", info);

	return (
		<div className="listingSection__wrap !space-y-6">
			{/* 1 */}
			<div className="flex justify-between items-center">
				<div>
					<Badge
						type={info.category}
						href={""}
						color={"pink"}
					/>
					<span
						className="ml-2"
					>
						·
					</span>
					<span className="text-md text-gray-500 ml-2">
						{productType.find ((item: any) => item.key === info.type).label}
					</span>
				</div>
				{/* {
					
					info.type === 'motorcycle'
					?
						<Badge name="모터싸이클 투어" />
					:
						<Badge name="test" />
				} */}
			
				{/* <LikeSaveBtns /> */}
			</div>

			{/* 2 */}
			<h2 className="text-2xl sm:text-3xl lg:text-4xl font-GothicA1 font-semibold">
				{info.title}
			</h2>

			{/* 4 */}
			<div className="flex items-center">
				<Avatar 
					hasChecked 
					sizeClass="h-10 w-10" 
					radius="rounded-full"
					imgUrl={info.travelAgency_logo}
					userName={info.travelAgency_name}
				/>
				<span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
					에이전시 {" "}
					<span className="text-neutral-900 dark:text-neutral-200 font-medium">
						{info.travelAgency_name}
					</span>
				</span>
			</div>

			{/* 5 */}
			{/* <div className="w-full border-b border-neutral-100 dark:border-neutral-700" /> */}

			{/* 6 */}
			{/* <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
			<div className="flex items-center space-x-3 ">
				<i className=" las la-user text-2xl "></i>
				<span className="">
				{info.minGuests} ~ {info.maxGuests}<span className="hidden sm:inline-block"></span>
				</span>
			</div>
			<div className="flex items-center space-x-3">
				<i className=" las la-motorcycle text-2xl"></i>
				<span className=" ">
				<span className="hidden sm:inline-block">$1700 ~ $3100</span>
				</span>
			</div>
			<div className="flex items-center space-x-3">
				<i className=" las la-address-book text-2xl"></i>
				<span className=" ">
				<span className="hidden sm:inline-block">여권 6개월 이상</span>
				</span>
			</div>
			<div className="flex items-center space-x-3">
				<i className="las la-bed text-2xl"></i>
				<span className=" ">
					<span className="hidden sm:inline-block">숙박 9박(조식 포함)</span>
				</span>
			</div> 
			</div> */}
		</div>
	);
};